import React, { Component } from 'react';
import { Spin } from 'antd';
import cls from 'classnames';
import ListSearch from './FormSearch';
import ListTable from './Table';
import ListCreate from './CreateBtn';
import Pagination from './Pagination';
import styles from './index.less';

class List extends Component {
  static ListTable = ListTable;

  static ListSearch = ListSearch;

  static ListCreate = ListCreate;

  static Pagination = Pagination;

  render() {
    const { spinProps, children, className, ...otherProps } = this.props;
    return (
      <div className={cls({ [styles.root]: true, [className]: true })} {...otherProps}>
        <Spin {...spinProps}>{children}</Spin>
      </div>
    );
  }
}

export default List;
